import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { ClipboardList } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { AppHeader } from "../components/AppHeader";
import { StatusBadge } from "../components/StatusBadge";

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "-" : date.toLocaleString("ms-MY");
};

function Orders() {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!user || user === false || user.role === "admin") return;
    api.get("/me/orders")
      .then(({ data }) => setOrders(data))
      .catch(() => setOrders([]))
      .finally(() => setLoaded(true));
  }, [user]);

  if (loading) return null;
  if (!user || user === false) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <AppHeader />
      <main className="max-w-6xl mx-auto px-4 py-8 sm:py-10">
        <div className="mb-6 flex items-start justify-between gap-4">
          <div>
            <div className="mb-2 flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.25em] text-violet-400">
              <ClipboardList className="h-4 w-4" /> Sejarah
            </div>
            <h1 className="font-heading text-3xl font-black tracking-tight">Order</h1>
            <p className="mt-2 text-sm text-zinc-500">Senarai order anda, terbaru di atas.</p>
          </div>
          <div className="rounded-xl border border-violet-500/25 bg-violet-500/10 px-3 py-2 text-right">
            <div className="text-[10px] uppercase tracking-widest text-violet-300">Jumlah Order</div>
            <div className="font-heading text-xl font-bold text-white">{orders.length}</div>
          </div>
        </div>

        <div className="overflow-hidden rounded-2xl border border-white/5 bg-[#0f0f12]">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[760px] text-sm">
              <thead>
                <tr className="border-b border-white/5 text-left text-xs text-zinc-500">
                  <th className="px-5 py-4 font-medium">Service</th>
                  <th className="px-5 py-4 font-medium">Link</th>
                  <th className="px-5 py-4 font-medium">Quantity</th>
                  <th className="px-5 py-4 font-medium">Price</th>
                  <th className="px-5 py-4 font-medium">Status</th>
                  <th className="px-5 py-4 font-medium">Tarikh Order</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order.id} className="border-b border-white/5 last:border-0" data-testid={`order-row-${order.id}`}>
                    <td className="max-w-[220px] px-5 py-4 font-medium text-white">
                      <div className="truncate" title={order.service_name}>{order.service_name || "-"}</div>
                      {order.service_code && <div className="mt-1 font-mono text-xs text-violet-400">[{order.service_code}]</div>}
                    </td>
                    <td className="max-w-[240px] px-5 py-4 text-zinc-400">
                      <div className="truncate" title={order.target_link}>{order.target_link || "-"}</div>
                    </td>
                    <td className="px-5 py-4 font-mono text-zinc-300">{order.quantity ?? "-"}</td>
                    <td className="px-5 py-4 whitespace-nowrap font-mono text-zinc-300">RM {Number(order.cost || 0).toFixed(2)}</td>
                    <td className="px-5 py-4"><StatusBadge status={order.status} /></td>
                    <td className="px-5 py-4 whitespace-nowrap text-xs text-zinc-500">{formatDate(order.created_at)}</td>
                  </tr>
                ))}
                {loaded && orders.length === 0 && (
                  <tr><td colSpan="6" className="px-5 py-12 text-center text-zinc-500">Belum ada order</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Orders;